// Snake & Ladder — frontend GameModule export.
//
// This is the ONLY file the registry imports. Adding the import line
// to player-frontend/src/games/registry.ts is the entire wire-up
// needed for App.tsx to mount the /games/snake_ladder route, for the
// GameGrid lobby tile to render, and for the admin settings page to
// auto-discover the game.
import type { GameModule } from '../types';
import Page from './Page';

const snakeLadder: GameModule = {
  id:          'snake_ladder',
  displayName: 'Snake & Ladder',
  tag:         'Board',
  theme: {
    gradient: 'from-lime-500 to-green-700',
    emoji:    '🐍',
    logo:     '/games/snake_ladder/Logo.png',
  },
  // The 10×10 board fits a portrait viewport much better than landscape;
  // the existing desktop carve-out keeps wider screens centered without
  // forced rotation.
  orientation: 'portrait',
  Page,
  adminIcon: 'casino',
  adminTheme: {
    headerFrom:  'from-emerald-900',
    headerTo:    'to-lime-800',
    ring:        'ring-emerald-400',
    accent:      'bg-emerald-600',
    accentHover: 'hover:bg-emerald-500',
    dot:         'bg-emerald-400',
    softBg:      'bg-emerald-900/30',
    rangeAccent: 'accent-emerald-500',
    badgeClasses: 'bg-emerald-600/20 text-emerald-300 border-emerald-600/30',
  },
};

export default snakeLadder;
